/**
 * Communities domain routes
 */

import type { PromptType } from '@communities/prompt-management/domain';

export const routes = {
  communityGroups: {
    root: '/community-groups',
    detail: (groupId: string) => `/community-groups/${groupId}`,
  },
  communities: {
    root: '/communities',
    detail: (communityId: string) => `/communities/${communityId}`,
    classificationTesting: {
      root: (communityId: string) => `/communities/${communityId}/classification-testing`,
      withPrompt: (communityId: string, promptVersion: string, options?: { promptType?: PromptType }) => {
        const params = new URLSearchParams({ promptVersion });

        if (options?.promptType) {
          params.set('promptType', options.promptType);
        }

        return `/communities/${communityId}/classification-testing?${params.toString()}`;
      },
    },
    contentSearch: {
      root: (communityId: string) => `/communities/${communityId}/content-search`,
    },
    pageHeroExample: {
      root: (communityId: string) => `/communities/${communityId}/page-hero-example`,
    },
    moderation: {
      root: (communityId: string) => `/communities/${communityId}/moderation`,
      traits: (communityId: string) => `/communities/${communityId}/moderation/traits`,
    },
    caseSearch: {
      root: (communityId: string) => `/communities/${communityId}/case-search`,
    },
  },
};
